import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const showSmnCaPpageCarouselSelector = createSelector(testTargetOffersSelector, offers => offers?.SmnCaPpageCarousel || Empty.Object);

export { showSmnCaPpageCarouselSelector };
